import React, { useEffect, useState } from 'react'
import ExpandablePanel from 'components/ExpandablePanel'
import styled from 'styled-components'
import { useDispatch, useSelector } from 'react-redux'
import { fetchTeachersListRoutine } from 'modules/teachers/ducks/actions'
import { selectTeachersWithStats } from 'modules/teachers/ducks/selectors'
import Table from 'components/Table'
import Modal from 'components/Modal'
import { isNotNilOrEmpty } from 'utils/ramda'
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
import { DATE_FORMATS, formatDate } from 'utils/date';
import { Tooltip } from '@mui/material'
import { PieChart } from 'react-minimal-pie-chart'

const TeacherStats = () => {
  const dispatch = useDispatch()
  const teachers = useSelector(selectTeachersWithStats)
  const [selectedTeacher, setSelectedTeacher] = useState(null)
  const [activeTab, setActiveTab] = useState('added-students')

  useEffect(() => {
    dispatch(fetchTeachersListRoutine())
  }, [])

  return (
    <>
      <PageHeader>
        Statystyki nauczycieli
      </PageHeader>
      <ExpandablePanel startOpen title='Lista nauczycieli'>
        <div>
          <StyledTable>
            <thead>
              <tr>
                <th />
                <th style={{ textAlign: 'center' }} colSpan={3}>Dodani</th>
                <th style={{ textAlign: 'center' }} colSpan={5}>Rezygnacje</th>
                <th style={{ textAlign: 'center' }} colSpan={2}>Współczynniki</th>
                <th />
              </tr>
              <tr>
                <th>Nauczyciel</th>
                <th>Jednorazowi</th>
                <th>Pozostali</th>
                <th>Wszyscy</th>

                <th>Pochwała</th>
                <th>Fail</th>
                <th>Matura</th>
                <th>N/A</th>
                <th>Wszystkie</th>

                <th>Rezygnacje/dodani</th>
                <th>Faile/Rezygnacje</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {teachers?.map(teacher => {
                const addedStudents = teacher.addedStudents?.length || 0
                const resignations = teacher.resignations?.length || 0

                const oneTimeResignations = teacher.resignations?.filter(resignation => resignation.one_time) || []

                const getResignationsCount = (resignations) => {
                  const faileedLabels = ['Fail', 'Rezygnacja nauczyciela z ucznia']
                  const failed = resignations?.filter(resignation => faileedLabels.includes(resignation.reason))?.length || 0
                  const success = resignations?.filter(resignation => resignation.reason === 'Pochwała')?.length || 0
                  const na = resignations?.filter(resignation => resignation.reason === 'N/A')?.length || 0
                  const matura = resignations?.filter(resignation => resignation.reason === 'Matura')?.length || 0
                  return { failed, success, na, matura, all: failed + success + na + matura }
                }

                const allResignationsCount = getResignationsCount(teacher.resignations)
                const oneTimeResignationsCount = getResignationsCount(oneTimeResignations)

                return (
                  <tr key={teacher.id}>
                    <td>{teacher.name}</td>
                    <td>{oneTimeResignationsCount.all}</td>
                    <td>{addedStudents - oneTimeResignationsCount.all}</td>
                    <td>{addedStudents}</td>
                    <td>{allResignationsCount.success}</td>
                    <td>{allResignationsCount.failed}</td>
                    <td>{allResignationsCount.matura}</td>
                    <td>{allResignationsCount.na}</td>
                    <td>{resignations}</td>
                    <td>
                      <Tooltip title={(
                        <>
                        <CharsWrapper>
                          {resignations === 0 && (
                            <p>Brak rezygnacji</p>
                          )}
                          {addedStudents > 0 && (
                            <div>
                              <p>Rezygnacje/dodani</p>
                              <PieChart
                                style={{ width: '120px', height: '120px' }}
                                label={({ dataEntry }) => dataEntry.value}
                                data={[
                                  ...(addedStudents - resignations > 0 ? [{ title: 'Dodani', value: addedStudents - resignations, color: 'lightgreen' }] : []),
                                  ...(resignations > 0 ? [{ title: 'Rezygnacje', value: resignations, color: 'lightcoral' }] : []),
                                ]}
                              />
                              <p style={{ marginTop: '8px', marginBottom: '0', textAlign: 'right' }}>Suma: {addedStudents}</p>
                            </div>
                          )}
                        </CharsWrapper>
                        </>
                      )}>
                        <div>
                          {(resignations / addedStudents).toFixed(2)}
                        </div>
                      </Tooltip>
                    </td>
                    <td>
                      <Tooltip title={(
                        <>
                        <CharsWrapper>
                          {allResignationsCount.all === 0 && (
                            <p>Brak rezygnacji</p>
                          )}
                          {allResignationsCount.all > 0 && (
                            <div>
                              <p>Faile/Rezygnacje</p>
                              <PieChart
                                style={{ width: '120px', height: '120px' }}
                                label={({ dataEntry }) => dataEntry.value}
                                data={[
                                  ...(allResignationsCount.all - allResignationsCount.failed > 0 ? [{ title: 'Inne', value: allResignationsCount.all - allResignationsCount.failed, color: 'lightblue' }] : []),
                                  ...(allResignationsCount.failed > 0 ? [{ title: 'Faile', value: allResignationsCount.failed, color: 'lightcoral' }] : []),
                                ]}
                              />
                              <p style={{ marginTop: '8px', marginBottom: '0', textAlign: 'right' }}>Suma: {allResignationsCount.all}</p>
                            </div>
                          )}
                        </CharsWrapper>
                        </>
                      )}>
                        <div>
                          {(allResignationsCount.failed / allResignationsCount.all || 0).toFixed(2)}
                        </div>
                      </Tooltip>
                    </td>
                    <td style={{ cursor: 'pointer', textAlign: 'right' }}>
                      <RemoveRedEyeOutlinedIcon onClick={() => setSelectedTeacher(teacher)} />
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </StyledTable>
        </div>
      </ExpandablePanel>
      <Modal
        title={selectedTeacher?.name}
        open={isNotNilOrEmpty(selectedTeacher)}
        onClose={() => setSelectedTeacher(null)}
        width='800px'
      >
        <TabsWrapper>
          <Tab active={activeTab === 'added-students'} onClick={() => setActiveTab('added-students')}>
            Dodani uczniowie ({selectedTeacher?.addedStudents?.length || 0})
          </Tab>
          <Tab active={activeTab === 'resignations'} onClick={() => setActiveTab('resignations')}>
            Rezygnacje ({selectedTeacher?.resignations?.length || 0})
          </Tab>
        </TabsWrapper>
        {
          activeTab === 'added-students' && (
            <Table>
              <thead>
                <tr>
                  <th>Uczeń</th>
                  <th>Data dodania</th>
                </tr>
              </thead>
              <tbody>
                {selectedTeacher?.addedStudents?.map(student => (
                  <tr key={student.id}>
                    <td>{student.name}</td>
                    <td>{formatDate(student.date, DATE_FORMATS.withTimeAndSeconds)}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          )
        }
        {
          activeTab === 'resignations' && (
            <>
            <Table>
              <thead>
                <tr>
                  <th>Uczeń</th>
                  <th>Powód</th>
                  <th>Data</th>
                  <th>Jednorazowy</th>
                  <th>Komentarz</th>
                </tr>
              </thead>
              <tbody>
                {selectedTeacher?.resignations?.map(resignation => (
                  <tr key={resignation.id}>
                    <td>{resignation?.student_name || ''}</td>
                    <td>{resignation?.reason || ''}</td>
                    <td>{formatDate(resignation.created_at, DATE_FORMATS.withTimeAndSeconds)}</td>
                    <td>{resignation.one_time ? 'Tak' : 'Nie'}</td>
                    <td>{resignation.comment || ''}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
            </>
          )
        }
      </Modal>
    </>
  )
}

export default TeacherStats

const PageHeader = styled.div`
  font-size: 24px;
  margin-bottom: 20px;
`

const TabsWrapper = styled.div`
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
`

const Tab = styled.div`
  cursor: pointer;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  width: 100%;
  text-align: center;
  
  ${({ active, theme }) => active && `
    background-color: ${theme.colors.primary.main};
    border-color: ${theme.colors.primary.main};
    color: #fff;
  `}
`

const CharsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;

  p {
    margin-bottom: 10px;
    text-align: center;
  }
`

const StyledTable = styled.table`
  width: 100%;
  margin-top: 20px;
  font-size: 12px;
  position: relative;
  border-collapse: separate;
  border-spacing: 0;
  
  th, td {
    text-align: center;
    padding: 5px;
    border: 1px solid #ccc;
  }
  
  tr:not(:last-of-type) {
    border-bottom: 1px solid ${({ theme }) => theme.colors.border};
  }
  
  th {
    border-bottom: 1px solid black;
    text-transform: uppercase;
    position: sticky;
    background-color: #fff;
    z-index: 1;
  }

  thead tr:first-child th {
    top: -20px;
    z-index: 3;
    height: 32px;
  }

  thead tr:nth-child(2) th {
    top: 12px;
    z-index: 2;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
  }

  @media (max-width: 768px) {
    thead tr:first-child th {
      top: -40px;
    }

    thead tr:nth-child(2) th {
      top: -8px;
    }
  }

  thead tr:hover {
    background-color: #fff;
  }
  
  tbody tr {
    transition: all .3s;

    &:hover {
      background-color: ${({ theme }) => theme.colors.lightGrey};
    }
  }

  th:nth-child(1), th[colspan="3"], th[colspan="5"], th:nth-child(4), th:nth-child(9), th:nth-child(11),
  tr > td:nth-child(1), tr > td:nth-child(4), tr > td:nth-child(9), tr > td:nth-child(11)
  {
    border-right: 2px solid #999999;
  }
`